
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forbesselectvacuumcleaner/book-a-demo",
      function () {
        return require("private-next-pages/forbesselectvacuumcleaner/book-a-demo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forbesselectvacuumcleaner/book-a-demo"])
      });
    }
  